import {Content, ContentLayoutRoot, Header} from "./ContentLayout";
import {TContentComponent} from "./types";

export const ContentLayout = Object.assign(ContentLayoutRoot, {
    Header: Header,
    Content: Content
}) as TContentComponent